import React from 'react'
import RestaurantShowcase from '../../components/RestaurantShowcase/RestaurantShowcase'

const Restaurants = () => {
  return (
    <div className='restaurants-page'>
      <RestaurantShowcase />
    </div>
  )
}

export default Restaurants
